var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('st-page',{attrs:{"title":_vm.$t('METADATA_MAPPING.PAGE_TITLE')}},[_c('mappings-match',{on:{"applicationMetadataSelected":_vm.applicationMetadataSelected}}),_c('mappings-table',{ref:"mappings-table"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }